import { useEffect, useState } from "react";
import { getContent } from "../lib/api";

export function useContent(resource) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    let active = true;
    setLoading(true);
    getContent(resource)
      .then((d) => active && setData(Array.isArray(d) ? d : []))
      .catch(() => active && setData([]))
      .finally(() => active && setLoading(false));
    return () => { active = false; };
  }, [resource]);
  return { data, loading };
}
